import loginStore from '@/pages/login/store'
import empManageStore from '@/pages/emp-manage/store'
import demoStore from '@/pages/demos/store'

export default {
  loginStore,
  empManageStore,
  demoStore
}